export const HEADER_KEY_DISABLE_ERROR_HANDLING = 'X-CityPantry-Disable-Error-Handling';
